<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ $t('contrato_tipos') }}</h2>

			<div class="mb-4">
				<label class="block mb-2">{{ $t('Tipo') }}</label>
				<input
					type="text"
					v-model="type"
					class="
						mt-2
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.type.$dirty">
					<div class="text-sm text-red-500 mt-2" v-if="!$v.type.maxLength">
						{{ $t('address_validation') }}
					</div>
				</div>
			</div>

			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { queryContractTypeByPk } from '@/apollo/queries/admin/contract_types'
import {
	updateSingleContractType,
	insertSingleContractType
} from '@/apollo/mutations/admin/contract_types'
import { single } from '@/mixins'

export default {
	apollo: {
		type() {
			const query = queryContractTypeByPk(this.id)
			query.skip = this.id == null
			return query
		}
	},
	data() {
		return {
			type: ''
		}
	},
	components: {
		PulseLoader
	},
	mixins: [single],
	validations() {
		return {
			type: {
				required,
				maxLength: maxLength(50)
			}
		}
	},
	methods: {
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$apollo
					.mutate(
						this.id
							? updateSingleContractType(this.id, this.type)
							: insertSingleContractType(this.type)
					)
					.then(() => this.stopLoadingState())
					.catch(error => this.setError(error))
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	}
}
</script>
